import React from "react";
import * as actions from '../Actions';

function changeQueChild(event, eleRef) {
    eleRef.setState({ childIdQuePost: event.target.value });
}

export default function QuestionOverlay({ eleRef, childData }) {
    if (childData) {
        childData = childData.filter(function (item) {
            return !item.IsExpected;
        });
    }
    return (
        <div className="askQuest-overlay" onClick={(e) => actions.closeQuestionPopup(e, eleRef)}>
            <div className="askQuest-popup">
                <div className="askQuest-header">
                    <span className="M18_48">Ask a Question</span>
                    <span className="closeButton icon" data-icon-font="C" onClick={(e) => actions.closeQuestionPopup(e, eleRef)}></span>
                </div>
                <div className="write-comment-container">
                    <textarea id="post_question_text" rows="4" cols="50" className="comment-box L14_74" placeholder="Write Your Question Here"></textarea>
                    <label htmlFor="fileupload">
                        <div className="qna-popup-attachment">
                            <div data-icon-font="o" className="icon R16_9e"></div>
                            <span className="R14_61">Attachments</span>
                        </div>
                    </label>
                    <div className="file_upload_err"></div>
                    <span className="que-asked-for">This question is being asked for: </span>
                    <div className="outer-child-container">
                        <div className="left askqueChild">
                            {childData && childData.length > 0 && childData.map((child, index) =>
                                <span key={index} className="child">
                                    <label>
                                        <input type="radio" value={child.ChildId} checked={eleRef.state.childIdQuePost == child.ChildId} onChange={(e) => changeQueChild(e, eleRef)}  className="dev_radiobuttons" id={child.gender}/>
                                        <span className="child-info-ask-quest">
                                            <span className="R14_42">{child.ChildName}</span>
                                            <span className="R11_75">{actions.getChildAge(child.DOB)}</span>
                                        </span>
                                    </label>
                                </span>
                            )}
                            <span className="myself">
                                <label>
                                    <input type="radio" value="all" checked={eleRef.state.childIdQuePost == "all"} onChange={(e) => changeQueChild(e, eleRef)} />
                                    <span className="child-info-ask-quest">
                                        <span className="R14_42">Myself</span>
                                    </span>
                                </label>
                            </span>
                        </div>
                    </div>
                    <div className="askque-post"><p className="b_1 right postcomment" id="devaskQuestion" onClick={() => actions.saveQuestion(eleRef.state.childIdQuePost, eleRef)}>POST</p></div>
                    <span className="your-identity">Your identity will not be revealed</span>
                    <div className="uploaded-files-list">
                        <ul>
                            <li className="cmt-image">
                                <span data-icon-font="`" className="icon left"></span>
                                <span className="added-file-name left"></span>
                                <span data-icon-font="&#xe013;" className="icon right" onClick={() => actions.cmtFileDelete('image', "que")}></span>
                            </li>
                            <li className="cmt-pdf">
                                <span data-icon-font="&#xe039;" className="icon left"></span>
                                <span className="added-file-name left"></span>
                                <span data-icon-font="&#xe013;" className="icon right" onClick={() => actions.cmtFileDelete('pdf', "que")}></span>
                            </li>
                        </ul>
                    </div>
                    <input type="file" id="fileupload" onChange={() => actions.cmtFileUpload()} style={{ display: 'none' }} />
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// src/shared/qna/common/QuestionOverlay.js